<template>
  <div v-if="!!source_uid && !!task_dto">
    <v-icon :small="small" v-if="task_dto.state==='SUCCESS'" color="green" @click="onDetail()">
      mdi-check-circle
    </v-icon>
    <v-icon :small="small" v-if="task_dto.state==='FAILURE'" color="red" @click="onDetail()">
      mdi-alert-circle
    </v-icon>
    <v-icon :small="small" v-if="task_dto.state==='PENDING'" color="orange" @click="onDetail()">
      mdi-pause-circle
    </v-icon>
    <v-icon :small="small" v-if="task_dto.state==='STARTED'" color="orange" @click="onDetail()">
      mdi-sync
    </v-icon>

    <v-dialog
        v-model="dialogItem"
        persistent
    >
      <v-card :height="componentHeight">
        <v-card :height="componentHeight - 50" class="overflow-y-auto">
          <v-row>
            <v-col cols="4">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                  <tr>
                    <td>UID</td>
                    <td>{{ task_dto.uid }}</td>
                  </tr>
                  <tr>
                    <td>Source name</td>
                    <td>{{ task_dto.source_name }}</td>
                  </tr>
                  <tr>
                    <td>Source UID</td>
                    <td>{{ task_dto.source_uid }}</td>
                  </tr>
                  <tr>
                    <td>Source IP</td>
                    <td>{{ task_dto.source_ip }}</td>
                  </tr>
                  <tr>
                    <td>Consumer name</td>
                    <td>{{ task_dto.consumer_name }}</td>
                  </tr>
                  <tr>
                    <td>Args</td>
                    <td>{{ task_dto.args }}</td>
                  </tr>
                  <tr>
                    <td>Kwargs</td>
                    <td>{{ task_dto.kwargs }}</td>
                  </tr>
                  <tr>
                    <td>Created on</td>
                    <td>{{ task_dto.create_on }}</td>
                  </tr>
                  <tr>
                    <td>Run on</td>
                    <td>{{ task_dto.run_on }}</td>
                  </tr>
                  <tr>
                    <td>End on</td>
                    <td>{{ task_dto.end_on }}</td>
                  </tr>
                  <tr>
                    <td>Retry count</td>
                    <td>{{ task_dto.retry_count }}</td>
                  </tr>
                  <tr>
                    <td>Priority</td>
                    <td>{{ task_dto.priority }}</td>
                  </tr>
                  <tr>
                    <td>Expire</td>
                    <td>{{ task_dto.result_ex }}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{{ task_dto.state }}</td>
                  </tr>
                  <tr>
                    <td>Result</td>
                    <td>{{ task_dto.result }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="8">
              <v-sheet>
                <v-textarea
                    class="mt-3 mx-3 px-3"
                    v-model="task_dto.error"
                    label="Error"
                    :disabled="false"
                    auto-grow
                    outlined
                >
                  <v-card-title>Error</v-card-title>
                  {{ task_dto.error }}
                </v-textarea>
                <v-textarea
                    class="mx-3 px-3"
                    v-model="task_dto.exception_traceback"
                    label="Traceback"
                    :disabled="false"
                    auto-grow
                    outlined
                >
                </v-textarea>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card>
        <v-toolbar class="justify-end" height="32">
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="onCancel()"
          >Close
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'

export default {
  name: 'CommonTaskIcon',
  inheritAttrs: false,
  props: {
    source_uid: {default: null},
    width: {default: 2},
    small: {default: true},
    size: {default: 20},
    subtractHeight: {type: [Number], default: 240},
    height: {type: [Number], default: window.innerHeight},
  },

  components: {},

  computed: {
    task_dto() {
      if (!!this.aggregateStore)
        return this.aggregateStore.source_uid_task[this.source_uid]
    },
    componentHeight() {
      return this.$vuetify.breakpoint.height * 0.95 - 39
    },
  },

  methods: {
    onDetail() {
      this.dialogItem = true
    },
    onCancel() {
      this.dialogItem = false
    },
    exception_traceback(editedItem) {
      if (!!editedItem && !!editedItem.exception_traceback)
        return editedItem.exception_traceback.replace('\n', '<br><br>')
    },
    error(editedItem) {
      if (!!editedItem && !!editedItem.error)
        return editedItem.error.replace('\n', '<br><br>')
    },
  },

  async mounted() {
    this.aggregateStore = useAggregateStore()
  },

  data() {
    return {
      aggregateStore: null,
      dialogItem: false,
    }
  }
}
</script>

<style scoped lang="scss">

</style>
